export type RestrictionType = 'minlos' | 'maxlos';

export interface Restriction {
  room_id: string;
  package_id?: string;
  type: RestrictionType;
  value: number;
}

export interface CalendarRoomType {
  id: string;
  name: string;
}

export interface CalendarRoom {
  id: string;
  package: string;
  available: number;
  closed: boolean;
  cta: boolean;
  ctd: boolean;
  maxlos: number;
  minlos: number;
  rate: number;
}

export type RawAvailabilityCalendar = {
  [date: string]: {
    room_type_id: number | string | null;
    package_id?: number | null;
    association_id?: number | null;
    rate_id?: number;
    rate: string;
    min_l: number;
    max_l: number;
    cta: number;
    ctd: number;
    avail: number;
    closed: number;
  }[];
};

export interface CalendarDay {
  date: string;
  time: number;
  available: boolean;
  availableRooms: number;
  rooms: CalendarRoom[];
  restrictions: Restriction[];
  closed: boolean;
  closeToArrival: boolean;
  closeToDeparture: boolean;
  ctaOrFullOccupancy: boolean;
  ctdOrFullOccupancy: boolean;
  maxLengthOfStay: number;
  minLengthOfStay: number;
  gtMaxLengthOfStay: number;
  gtMinLengthOfStay: number;
}

export interface Calendar {
  rawAvailabilityCalendar: RawAvailabilityCalendar;
  roomTypes: CalendarRoomType[];
}

export class Day {
  date = '1970-01-01';
  time = 0;
  val = 0;

  today = false;
  past = false;
  available = true;
  availableRooms = 0;
  previousDay?: Day = undefined;

  closed = false;
  closeToArrival = false;
  closeToDeparture = false;
  ctaOrFullOccupancy = false;
  ctdOrFullOccupancy = false;
  maxLengthOfStay = 0;
  minLengthOfStay = 1;

  restrictions: Restriction[] = [];
  blockReasons: string[] = [];
  rooms: CalendarRoom[] = [];

  data?: CalendarDay = undefined;

  constructor(calendarDay?: CalendarDay) {
    if (!calendarDay) return;

    this.data = calendarDay;
    this.date = calendarDay.date;
    this.available = calendarDay.available;
    this.availableRooms = calendarDay.availableRooms;
    this.time = calendarDay.time;
    this.restrictions = calendarDay.restrictions;
    this.rooms = calendarDay.rooms;
    this.closed = calendarDay.closed;
    this.closeToArrival = calendarDay.closeToArrival;
    this.closeToDeparture = calendarDay.closeToDeparture;
    this.ctaOrFullOccupancy = calendarDay.ctaOrFullOccupancy;
    this.ctdOrFullOccupancy = calendarDay.ctdOrFullOccupancy;
    this.maxLengthOfStay = calendarDay.maxLengthOfStay;
    this.minLengthOfStay = calendarDay.minLengthOfStay;
  }
}

export default Calendar;
